import 'framework7/lite-bundle';
import 'framework7-icons/css/framework7-icons.css';
import './styles/framework7-bundle.css'; 

import './index.css';                  
import '@styles/BottomTabBar.css';     
import '@styles/supportPage.css';      

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

import Framework7 from 'framework7/lite-bundle';
import Framework7React from 'framework7-react';

// eslint-disable-next-line react-hooks/rules-of-hooks
Framework7.use(Framework7React);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
